module.exports = __webpack_public_path__ + "img/saved-time.ded16ae1.svg";